import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import Header from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <CheckCircle2 className="h-12 w-12 mx-auto text-green-600 mb-5" />
            <h1 className="font-display text-2xl font-medium mb-3">Check your email</h1>
            <p className="text-sm text-neutral-600 mb-6">
              If <span className="font-medium">{email}</span> is registered, we've sent a reset link. The link expires in 1 hour.
            </p>
            <Link to="/login"><Button variant="ghost" className="rounded-full" data-testid="forgot-back-login">Back to login</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl tracking-tight font-medium mb-2">Reset your password</h1>
            <p className="text-neutral-600 mb-8 text-sm">Enter your email and we'll send you a link to set a new password.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Email</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 rounded-xl" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="w-full rounded-full bg-blue-600 hover:bg-blue-700 h-11" data-testid="forgot-submit">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <p className="text-sm text-center text-neutral-500 mt-6">
              Remembered? <Link to="/login" className="text-blue-600 font-medium">Log in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
